import { LoadingState } from '../components/system/LoadingState.tsx'
import { useI18n } from '../lib/i18n/i18n-store.ts'

/**
 * Suspense fallback while a screen's chunk loads. LoadingState stays invisible
 * for its first moments, so a chunk served from the service worker cache never
 * flashes a spinner.
 */
export function RouteFallback() {
  const { t } = useI18n()
  return <LoadingState label={t('common.loading')} />
}
